import { RadioOption } from './radio-option';

export type RadioOptions = Readonly<{ [key: string]: RadioOption[] | undefined }>;

export const initialRadioOptions = {};
